import React from 'react';
import Reveal from '../ui/Reveal';

const Founder = () => {
  return (
    <section id="founder" className="py-24 md:py-32 bg-navy-900 text-white relative overflow-hidden">
      {/* Background Accent */}
      <div className="absolute top-0 right-0 w-1/2 h-full bg-navy-800 hidden lg:block"></div>

      <div className="max-w-7xl mx-auto px-6 lg:px-12 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          
          {/* Image */}
          <Reveal direction="right">
            <div className="relative">
              <div className="aspect-[3/4] w-full max-w-md mx-auto lg:mx-0 overflow-hidden relative">
                <img 
                  src="https://i.postimg.cc/VkjG7j9d/Whats-App-Image-2026-04-05-at-4-13-23-PM.jpg" 
                  alt="Romita Khurana Sahni" 
                  className="w-full h-full object-cover grayscale opacity-90 hover:grayscale-0 transition-all duration-700"
                />
                <div className="absolute inset-0 border-2 border-gold-500 m-4 pointer-events-none"></div>
              </div>
            </div>
          </Reveal>

          {/* Content */}
          <Reveal direction="left" delay={0.2}>
            <div className="lg:pl-8">
              <span className="text-gold-500 uppercase tracking-[0.2em] text-sm font-semibold block mb-4">The Visionary</span>
              <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl mb-2">Romita Khurana Sahni</h2>
              <p className="text-gray-400 font-serif text-xl italic mb-8">Author, Entrepreneur, Publicist</p>
              
              <div className="space-y-6 text-gray-300 font-light leading-relaxed mb-10">
                <p>
                  As an author, curator, and celebrated media personality, Romita brings a profound understanding 
                  of narrative structure to the world of public relations.
                </p>
                <p>
                  Her storytelling instinct ensures that every brand she touches is imbued with a 
                  "literary soul," transforming standard corporate messaging into compelling cultural conversations.
                </p>
              </div>

              {/* Accolades */}
              <div className="grid grid-cols-2 gap-6 border-t border-gray-700 pt-8">
                <div>
                  <h4 className="text-white font-medium mb-1">TEDx Anchor</h4>
                  <p className="text-sm text-gray-500">Commanding stages globally</p>
                </div>
                <div>
                  <h4 className="text-white font-medium mb-1">CNBC Panelist</h4>
                  <p className="text-sm text-gray-500">Industry thought leadership</p>
                </div>
                <div className="col-span-2">
                  <h4 className="text-gold-400 font-medium mb-1">Women Achievers Award 2024</h4>
                  <p className="text-sm text-gray-500">Recognized for excellence in media & PR</p>
                </div>
              </div>
            </div>
          </Reveal>

        </div>
      </div>
    </section>
  );
};

export default Founder;